import Quill from 'quill'

export default class ImageResizeFix {
  constructor (resizer) {
    this.overlay = resizer.overlay
    this.img = resizer.img
    this.options = resizer.options
    this.requestUpdate = resizer.onUpdate
    this.onCreate = () => {}
    this.onDestroy = () => {}
    this.onUpdate = () => {}
    resizer.quill.setSelection(resizer.quill.getIndex(Quill.find(this.img)), 1)
  }
}



// WEBPACK FOOTER //
// ./src/macarons/quill/ImageResizeFix.js